import React from 'react';
import {
    CogIcon,
    BookOpenIcon,
    ClipboardDocumentListIcon,
    ClockIcon,
    ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';
import {
    ROLE_ADMIN,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_COLLABORATOR_EDITOR,
} from '@/contexts/AuthContext';

export interface NavigationItem {
    name: string;
    href: string;
    icon: React.ElementType;
    requiredRoles?: string[];
}

const managementRoles = [
    ROLE_ADMIN,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_COLLABORATOR_EDITOR,
];

export const COLLABORATOR_NAVIGATION: NavigationItem[] = [
    {
        name: 'Diretório',
        href: '/collaborators/directory',
        icon: BookOpenIcon,
    },
    {
        name: 'Gestão',
        href: '/collaborators/updates',
        icon: CogIcon,
        requiredRoles: managementRoles,
    },
    {
        name: 'Alocações',
        href: '/collaborators/allocations',
        icon: ClipboardDocumentListIcon,
        requiredRoles: managementRoles,
    },
    {
        name: 'Disponibilidades',
        href: '/collaborators/availabilities',
        icon: ClockIcon,
        requiredRoles: managementRoles,
    },
    {
        name: 'Avaliações',
        href: '/collaborators/evaluations',
        icon: ClipboardDocumentCheckIcon,
    },
];
